import type { Message, ConversationSummary, StepRecord } from "../types";
import { formatConversationDate } from "../utils";

export type DrawerMode = "conversation" | "message" | null;
type GearClickAction = "open" | "close";
type MessageClickAction = "select" | "deselect";

export function getGearClickAction(drawerMode: DrawerMode): GearClickAction {
    if (drawerMode === "conversation") return "close";
    return "open";
}

export function getMessageClickAction(
    messageId: Message["id"],
    selectedMessageId: Message["id"] | null
): MessageClickAction {
    if (messageId === selectedMessageId) return "deselect";
    return "select";
}

export function resolveConversationDate(
    conversationId: number | null,
    conversations: ConversationSummary[],
    messages: Message[]
): string | null {
    if (conversationId !== null) {
        const conv = conversations.find(c => c.id === conversationId);
        if (conv) return formatConversationDate(conv.created);
    }
    const firstMsg = messages.find(m => m.created !== 0);
    if (firstMsg) return formatConversationDate(firstMsg.created / 1000);
    return null;
}

export function formatStepsJson(steps: StepRecord[]): string {
    return JSON.stringify(steps, null, 2);
}
